import React from "react";

const Footer = () => {
  return (
    <footer className="fixed bottom-0 right-0 px-4 my-2 bg-gray-800 text-[#00555C] text-xs font-bold">
      <i>powered by IOH, Lintasarta, and Accenture</i>
    </footer>

    // <footer className="fixed bottom-0 right-0 px-4 my-2 bg-gray-800 text-[black] text-xs font-bold">
    //   <i>powered by IOH, Lintasarta, and Accenture</i>
    // </footer>

    
    // <footer className="fixed bottom-0 right-0 px-4 my-2 bg-gray-800 text-[white] bg-[#00555C] text-xs font-bold">
    //   <i>powered by IOH, Lintasarta, and Accenture</i>
    // </footer>
  );
};

export default Footer;
